import objectById from '@clearscore/helpers.state-normalise';

import initialNormalisedState from './initial-normalised-state';

export default (payload, transformer) => {
    const results = payload?.results;
    if (!results) return initialNormalisedState;

    const byId = objectById(transformer(results));

    return {
        byId,
        allIds: Object.keys(byId),
    };
};
